import React, { useState, useEffect, useContext } from 'react';
import * as EmailValidator from 'email-validator';
import MainLayout from './MainLayout.jsx';
import * as routes from '../constants/routes';
import SessionContext from './SessionContext';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap'
import { InvitationRow } from './OnboardingPage.jsx';
import Loading from './Loading';
import moment from 'moment';

function SettingsPage({ history }) {
  const sessionContext = useContext(SessionContext);
  const [loading, setLoading] = useState(true)
  const [newHouseholdName, setNewHouseholdName] = useState('')
  const [members, setMembers] = useState([])
  const [emails, setEmails] = useState([])
  const [submitting, setSubmitting] = useState(false)

  const valid = newHouseholdName.length > 4

  const handleSubmit = async () => {
    setSubmitting(true)
    const invites = emails.filter(email => EmailValidator.validate(email))
                                                          .map(email => `{ email: "${email}" }`)

    const client = sessionContext.getGraphqlClient()
    const query = `
      mutation UpdateHousehold {
        updateHousehold(householdId: "${sessionContext.household.householdId}", title: "${newHouseholdName}", invites: [${invites}]) {
          householdId
          title
          schedules {
            scheduleId
            title
          }
          members {
            given_name
            family_name
            picture
          }
        }
      }
    `
    const request = {
      query,
      variables: null,
      operationName: 'UpdateHousehold'
    };

    try {
      const createResp = await client(request)
      sessionContext.setHousehold(createResp.data.updateHousehold);
      setEmails([])
      fetchMembers()
    } catch(e) {
      console.error(e)
    } finally {
      setSubmitting(false)
    }
  }

  const fetchMembers = async () => {
    setLoading(true)
    const client = sessionContext.getGraphqlClient()
    const query = `
      query CurrentHousehold {
        myProfile {
          currentHousehold {
            members {
              given_name
              family_name
              picture
              inviteStatus
              joinedAt
            }
          }
        }
      }
    `
    const request = {
      query,
      variables: null,
      operationName: 'CurrentHousehold'
    };

    try {
      const response = await client(request)
      setMembers(response.data.myProfile.currentHousehold.members.filter(m => m.inviteStatus !== 'invited'))
    } catch(e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  const handleLogout = () => {
    sessionContext.logout()
    history.push(routes.LANDING)
  }

  useEffect(() => {
    if(!sessionContext.isLoading) {
      setNewHouseholdName(sessionContext.household.title)
      fetchMembers()
    }
  }, [sessionContext.isLoading])

  return (
    <MainLayout>
      <Row>
        <Col xs={12}>
          {loading && <Loading fullPage={true} />}
          {!loading && <>
            <div className="tile" style={{marginTop: 28, position: 'relative'}}>
              <span className="title">My Settings</span>

              <div style={{marginTop: 14}}>
                <label style={{marginLeft: 26}}>Household Name</label>
                <input type="text" value={newHouseholdName} onChange={(e) => setNewHouseholdName(e.target.value)} className="form-control" />
              </div>

              <div className="invitationStep" style={{marginTop: 45}}>
                <label>Members</label>
                <div>
                  { members.map((member, index) => {
                    const lastItem = members.length - 1 === index;
                    return (<>
                      <div key={index} className="member">
                        <img src={member.picture} className="avatar" />
                        <div className="invitationInfo" style={{marginLeft: 15}}>
                          <h2>{member.given_name} {member.family_name}</h2>
                          <span>{ member.inviteStatus === 'creator' ? 'Owner' : `Joined ${moment(member.joinedAt).format('M/DD')}` }</span>
                        </div>
                      </div>
                      <div style={{height: 4, width: '100%', borderRadius: 2, backgroundColor: '#F2F6F7'}} />

                    </>)
                  })}
                </div>
              </div>

              <div className="invitationStep" style={{marginTop: 45}}>
                <label>Add New Members</label>
                <div style={{position: 'relative', top: -15}}>
                  { emails.map((email, index) => {
                    return (
                      <InvitationRow
                        key={index}
                        email={email}
                        onUpdateEmail={(value) => { emails[index] = value; setEmails(emails) }}
                        onDelete={() => setEmails(emails.filter((_, i) => i !== index))} />
                    )
                  })}
                  <InvitationRow onAdd={(email) => setEmails(emails.concat([email]))} />
                </div>
                <p style={{marginTop: 9}}>WFHScheduler requires a Google account to work, please make sure to send invites to Gmail addresses or companies using Google.</p>
              </div>

              <div style={{marginTop: 25, marginBottom: 25}}>
                <span className="title">Signed in as {sessionContext.user.name}</span>
                <button
                type="button"
                className="btn btn-border"
                onClick={handleLogout}
                disabled={!valid}
                style={{paddingLeft: 45, paddingRight: 45, display: 'block', marginTop: 15}}>
                  Logout
                </button>
              </div>
            </div>
            <div style={{marginTop: 19, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
              { submitting && <Loading submitButtons={true} />}
              { !submitting && <>
                <button
                  type="button"
                  className="btn btn-none"
                  onClick={() => history.goBack()}
                  style={{paddingLeft: 45, paddingRight: 45}}>
                    CANCEL
                  </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  disabled={!valid}
                  style={{paddingLeft: 45, paddingRight: 45, marginRight: 30}}>
                    SAVE
                </button>
              </>}
            </div>
          </>}
        </Col>
      </Row>
    </MainLayout>
  );
}

export default withRouter(SettingsPage)
